import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { DialogService, GridContentWidget } from "@eforall/dashboard";
import { ReadonlyAccessWidget } from "../../../readonly-access/readonly-access.widget";
import { AccVentureDialogDataService } from "../acc-venture-dialog-data.service";
import { getSetup } from "./grid/get-setup";

@Component({
	selector: 'acc-venture-entrepreneurs-part',
	standalone: true,
	imports: [
		GridContentWidget,
		ReadonlyAccessWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './entrepreneurs.part.html'
})
export class AccVentureEntrepreneursPart {

	private readonly util = inject(UtilityService);
	private readonly dialog = inject(DialogService);
	public readonly dialogDataService = inject(AccVentureDialogDataService);

	public dialogBodyHeight = input.required<number>();

	// subtracting 70 to account for padding and tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.dialogDataService.canEdit() ? 0 : 45));

	public setup = getSetup(this.util, this.dialog, this.dialogDataService);

}